import supabase from './supabaseClient'

class SupabaseCategoryService {
    async list() {
        const { data, error } = await supabase
            .from('categories')
            .select('id, name, description, created_at, updated_at')
            .order('updated_at', { ascending: false })
        if (error) throw new Error(error.message)
        return data || []
    }

    async create({ name, description }) {
        const payload = { name, description: description || null }
        const { data, error } = await supabase
            .from('categories')
            .insert(payload)
            .select('id, name, description, created_at, updated_at')
            .single()
        if (error) throw new Error(error.message)
        return data
    }

    async update(id, { name, description }) {
        const payload = { name, description: description || null }
        const { data, error } = await supabase
            .from('categories')
            .update(payload)
            .eq('id', id)
            .select('id, name, description, created_at, updated_at')
            .single()
        if (error) throw new Error(error.message)
        return data
    }

    async countArticlesInCategory(categoryId) {
        const { count, error } = await supabase
            .from('articles')
            .select('id', { count: 'exact', head: true })
            .eq('category_id', categoryId)
        if (error) throw new Error(error.message)
        return count || 0
    }

    async remove(id) {
        // 保护性检查：若有文章使用该分类则阻止删除
        const usingCount = await this.countArticlesInCategory(id)
        if (usingCount > 0) {
            throw new Error(`无法删除分类：还有 ${usingCount} 篇文章使用该分类`)
        }

        const { error } = await supabase
            .from('categories')
            .delete()
            .eq('id', id)
        if (error) throw new Error(error.message)
        return true
    }
}

const supabaseCategoryService = new SupabaseCategoryService()
export default supabaseCategoryService 